// Three modes: night, day, and mono. Night is the default. The mode sets a
// data-theme attribute on the root. tokens.css turns night and day into a
// `color-scheme`, and every light-dark() color follows. mono.css gives the
// third mode its own values. See also the inline boot script in
// index.html, which applies the stored mode before first paint.

import { STORAGE_KEY_THEME } from '../constants';
import { readText, writeText } from './storage';
import { createStore } from './store';

export type ThemeMode = 'dark' | 'light' | 'mono';

export const THEME_MODES: readonly ThemeMode[] = ['dark', 'light', 'mono'];

const isThemeMode = (value: string): value is ThemeMode =>
  (THEME_MODES as readonly string[]).includes(value);

const storedMode = readText(STORAGE_KEY_THEME, 'dark');

export const themeMode = createStore<ThemeMode>(isThemeMode(storedMode) ? storedMode : 'dark');

const applyThemeMode = (mode: ThemeMode): void => {
  document.documentElement.dataset.theme = mode;
  writeText(STORAGE_KEY_THEME, mode);
};

/** Call once at startup. */
export const startTheme = (): void => {
  applyThemeMode(themeMode.get());
  themeMode.subscribe(applyThemeMode);
};
